import React from "react";
import { format } from "date-fns";
import { Text } from "@networkraildigitalfactory/components";
import styles from "./CommentCard.module.css";

const CommentCard = ({ width = "100%", date, type, submittedBy, message }) => {
  let formattedMessage = message;
  if (typeof message === "string" && message.includes("\n")) {
    formattedMessage = message.split("\n");
  }

  return (
    <div className={styles.CommentCard} style={{ width }}>
      <span>{format(new Date(date), "dd/MM/yyyy - HH:mm")}</span>
      {type === "comment" && (
        <>
          <b>{submittedBy}</b>
          {typeof formattedMessage === "string" ? (
            <Text wrapper="p" style={{ marginBottom: "1em", color: "black" }}>
              {message}
            </Text>
          ) : (
            formattedMessage?.map((line, index) => {
              return (
                <Text
                  wrapper="p"
                  key={index}
                  type="body"
                  style={{ marginBottom: "1em", color: "black" }}
                >
                  {line}
                </Text>
              );
            })
          )}
        </>
      )}
      {type === "audit" && (
        <span className={styles.audit}>
          <b>{submittedBy} </b>
          <p>{message}</p>
        </span>
      )}
    </div>
  );
};

export default CommentCard;
